import React, { useState,useEffect } from "react";
import useRecorder from "../utils/useRecorder";
import { Container, Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import { ApiCall } from "../apicall";
import { SpeechMediaRecord } from "../Component/speechRecorder";
import Spinner from 'react-bootstrap/Spinner';
import { Microphone, Stop, ArrowLeft, ArrowRight, SpeakerHigh, Pause, ArrowClockwise, Play, Record } from 'phosphor-react';
import Wavesample from "./queriespage/waveform"
import fieldsLang from './queriespage/fieldsLang.json';
import JasonFile from './../Pages/queriespage/langVoiceCodes.json';
import { useNavigate } from "react-router";
function VoiceinputGpt() {
  const navigate = useNavigate();
  let [audioURL, isRecording, startRecording, stopRecording, pause, setPause, resume, setResume, setIsRecording, setReset] = useRecorder();
  const [fieldS, setFields] = React.useState("newuid");
  const [Text, setText] = React.useState("");
  const [queryUpdate, SetQueryUpdate] = React.useState('')
  const [relatedQuery, setRelatedQuery] = React.useState();
  const [cuurentQuery, setCurrentQuery] = React.useState('')
  const [queryLoader, setQueryLoader] = React.useState(false);
  const [suggestionLoader, setSuggestionLoader] = React.useState(false);
  const [currentLang, setCurrentLang] = useState('en-IN');
  const [audioSrc, setAudioSrc] = useState();
  const [buf, setBuf] = useState();
  const [prevAudio, setPrevAudio] = useState(null)
  const getBuf = data => {
    return Buffer.from(data, "binary");
  }

  const getQuerie = async (queryUpdate) => {
    setSuggestionLoader(true)
    const selectedLang = localStorage.getItem('selectedLang');
    const data = {
      text: queryUpdate,
      langSelected: selectedLang
    }
    await ApiCall('post', 'fetch-related-query-api', {}, data)
      .then(res => {
        setSuggestionLoader(false)
        setRelatedQuery(res.data.answer);
      })
      .catch(err => {
        setSuggestionLoader(false)
      })
  }

  const getQueryResp = async (textResponse, selectedLang) => {
    setQueryLoader(true)
    setCurrentQuery(textResponse.data ? textResponse.data : textResponse);
    let config = {
      'Content-Type': 'application/json'
    }
    let data = { text: textResponse.data ? textResponse.data : textResponse, langSelected: selectedLang }
    const output = await ApiCall("post", "fetch-query-api", config, data);
    // alert(output.data.answer);
    setText(output.data.answer);
    SetQueryUpdate(output.data.query)
    getQuerie(output.data.query)
    setQueryLoader(false);
  }
  useEffect(() => {
    const selectedLang = localStorage.getItem('selectedLang');
    const selectedQuery = localStorage.getItem('SelectedQueryAsInput');
    setCurrentLang(selectedLang)
    if (selectedQuery != undefined && selectedQuery != null && selectedQuery != '') {
      getQueryResp(selectedQuery, selectedLang);
    }
    chngeLng(cuurentQuery, setCurrentQuery)
  }, []);
  
  React.useEffect(() => {
    const fetchText = async () => {
      let fileName = `aud.wav`;
      let fd = new FormData();
      const output = await axios({
        method: 'get',
        url: audioURL, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
        responseType: 'blob'
      });
      const selectedLang = localStorage.getItem('selectedLang');
      let files = new File([output.data], fileName, { type: "audio/wav" });
      console.log(files);
      fd.append("file", files);
      fd.append("language", selectedLang)
      let config = {
        'Content-Type': 'multipart/form-data'
      }
      setQueryLoader(true);
      axios.post('https://voiceapi.aicte-india.org/voice-to-text', fd)
        .then(async res => {
          setQueryLoader(false);
          const textResponse = res.data
          if ((textResponse && textResponse.data !== '') && textResponse.data !== undefined) {
            getQueryResp(textResponse, selectedLang);
          }
        })
        .catch(errr => {
          setQueryLoader(false);
          alert("Invalid query!")
        })
    };
    if (audioURL !== undefined) {
      fetchText();
    }
  }, [audioURL]);

  useEffect(() => {
    const selectedLang = localStorage.getItem('selectedLang');
    setCurrentLang(selectedLang)
  }, [])


  const handleLanguage = async value => {
    localStorage.setItem('selectedLang', value);
    setCurrentLang(value);
    localStorage.setItem('selectedVoice', JasonFile[1][value]);
    chngeLng(cuurentQuery, setCurrentQuery)
  };

  const chngeLng = async (text, field) => {
    const selected_lang = localStorage.getItem("selectedLang")
    const data = { outputLang: selected_lang, text }
    await axios.post('https://voiceapi.aicte-india.org/text-to-text', data)
      .then(res => {
        field(res.data.data)
        getQueryResp(res.data.data, selected_lang)
      })
      .catch(err => { console.log(err) })
  }

  const handlePlayName =async(query) => {
    const langCode = localStorage.getItem('selectedLang');
    const langVoice = localStorage.getItem('selectedVoice');
    let post = {
      Body: query,
      language: langCode,
       voice: langVoice,
    };
    axios.post('https://voiceapi.aicte-india.org/text-to-voice', post)
      .then(res => {
        const audioFile = getBuf(res.data.data.audio.data)
        let blob = new Blob([audioFile], { type: 'audio/wav' });
        setBuf(blob);
        let url = URL.createObjectURL(blob);
        setAudioSrc(url);
      });
  }
  useEffect(() => {
    if (prevAudio) {
      prevAudio.pause();
      prevAudio.currentTime = 0;
    }
    const aud = new Audio(audioSrc);
    aud.play();
    setPrevAudio(aud);
  }, [audioSrc])

  return (
    <>
      <Container>
        <div className="App d-flex justify-content-between mt-5 mb-5 voiceDiv">
          <div className="" style={{ marginRight: 10 }}>
            <button onClick={e => { navigate("/govtofindiascheme") }}><ArrowLeft size={20} weight="bold"/> {fieldsLang[16][currentLang]}</button>
          </div>
          <div className="d-flex mb-3">
            {isRecording ?
              <React.Fragment>
                <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                  <Stop size={32} />
                </button>
                {pause != false ?
                  <>
                    <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}>{fieldsLang[19][currentLang]}<Record size={32} weight="fill"/></button>
                    <button className="stopbutton startbutton" onClick={() => { setText(""); setCurrentQuery("") }} disabled={!isRecording}>{fieldsLang[20][currentLang]}<ArrowClockwise size={32} weight="bold"/></button>
                  </>
                  :
                  <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} /></button>
                    {Text ? <button className="stopbutton startbutton" onClick={() => { setText(""); setCurrentQuery("") }} disabled={!isRecording}>{fieldsLang[20][currentLang]}<ArrowClockwise size={20} /></button> : ""}
                  </>
                }
              </React.Fragment>
              :
              <button className="startbutton" onClick={e => { startRecording(); setText("") }} disabled={isRecording}>
                {fieldsLang[10][currentLang]}<Microphone size={20} />
              </button>
            }
            {Text ? <button className="stopbutton btn-danger" onClick={() => { setText(""); setCurrentQuery("") }}>{fieldsLang[20][currentLang]}<ArrowClockwise size={20} /></button> : ""}
          </div>

          <div className="select-dropdown" style={{ marginRight: 10 }}>
            <select value={currentLang} onChange={e => { handleLanguage(e.target.value); }}>
              {Object.entries(JasonFile[0]).map((res, i) => {
                return (
                  <option key={i} value={res[0]}>
                    {res[1]}
                  </option>
                );
              })}
            </select>
          </div>

        </div>
      </Container>
      {cuurentQuery != "" ?<>
      
      <Container>
        <Row>
          <Col md={12} lg={12} xxl={12}>
            <Card className="leftbox2">
              <Card.Body>
                <h4>{cuurentQuery != "" ? cuurentQuery : <p>Click on  start recording and ask your Query to get a comprehensive response </p>} </h4>
                {cuurentQuery !="" ? <p className="playicon2" ><SpeakerHigh size={20} onClick={(e) => { handlePlayName(cuurentQuery) }} /></p> : ""}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={12} xxl={12}>
            {queryLoader == true ? <>       <Spinner animation="border" variant="dark" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner></> : <> <Card className="leftbox">
              <Card.Body>
                <h2>{Text != "" ? Text : <p></p>}</h2>
              </Card.Body>
            </Card> </>}
          </Col>
          <Col md={12} lg={12} xxl={12}>
          <Container className="bg-white mt-3">
          <Col className="card-div ">
          <Wavesample url={""} disc={Text} langg={localStorage.getItem('selectedLang')}/>
          </Col>
          </Container>
          </Col>
        </Row>
      </Container>
      <section className='cardsarea'>
        <Container>
          <div className='bordertop'>
            <Row>
              {suggestionLoader ? <>   <div className="newload">    <Spinner animation="border" role="status" variant="dark" >
                <span className="visually-hidden">Loading...</span>
              </Spinner></div></> : <>
                {relatedQuery ? <h3>{fieldsLang[15][localStorage.getItem("selectedLang")]}</h3> : <></>}
                {relatedQuery && relatedQuery.length > 0 ? relatedQuery.map((it, key) => (
                  <Col md={3} lg={3} xxl={3} key={key}>
                    {it.length > 0 ?
                    <>
                      <Card className="cardTwo" onClick={() => { getQueryResp(it, localStorage.getItem('selectedLang')) }}>
                        <Card.Body>
                          <Card.Title>{it}?
                          </Card.Title>
                        </Card.Body>
                      </Card> 
                      {it !="" ? <p className="playicon"><SpeakerHigh size={20} onClick={(e) => { handlePlayName(it) }} /></p> : ""}
                      </>: <></>}
                  </Col>
                )) : <></>}</>}
            </Row>
          </div>
        </Container>
      </section>
      
      </>:null}   

    </>
  );
}
export default VoiceinputGpt;


